import { PropsWithChildren } from 'react'

export function Balloon({ children }: PropsWithChildren) {
  return (
    <div className="pointer-events-auto mb-spacing8 max-w-[90%] animate-slide-up rounded-medium border border-neutral100 bg-neutral0 p-spacing16 text-center shadow-md">
      {children}
    </div>
  )
}
